import { Nullable } from '@/shared/types/app.types'

export interface SynopticTemplatesModalExternalDocumentationParams {
    laboratoryId: number
    synopticTemplateId: number
}

export interface SynopticTemplatesModalExternalDocumentationState {
    hasInitialFile: boolean
    file: Nullable<File>
}
export const initialSynopticTemplatesModalExternalDocumentationState =
    (): SynopticTemplatesModalExternalDocumentationState => ({
        hasInitialFile: false,
        file: null
    })
